import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { MdKeyboardBackspace as BackIcon } from "react-icons/md";
import { MdArrowForward as ForwardIcon } from "react-icons/md";

import Viewer from "../UI/Viewer";
import ContentWrapper from "../UI/ContentWrapper";
import AppBar, { AppBarContentWrapper } from "../AppBar/AppBar";
import { withPageTracker } from "utils/analytics/hooks";
import { Site } from "../../api/typedefs/Site";

interface SiteInfoProps extends RouteComponentProps {
  site: Site;
}

const SiteInfo: React.FC<SiteInfoProps> = ({ site, history }) => {
  const goBack = () =>
    history.action === "PUSH" ? history.goBack() : history.push("/");

  const scriptDirection = (site && site.scriptDirection) || "LTR";

  return (
    <Viewer>
      <AppBar showBackButton>
        <AppBarContentWrapper>
          {scriptDirection === "RTL" ? (
            <ForwardIcon size={24} onClick={goBack} />
          ) : (
            <BackIcon size={24} onClick={goBack} />
          )}
        </AppBarContentWrapper>
      </AppBar>
      <ContentWrapper scriptDirection={scriptDirection}>
        <div dangerouslySetInnerHTML={{ __html: site.description || "" }} />
      </ContentWrapper>
    </Viewer>
  );
};

export default withRouter(withPageTracker(SiteInfo));
